import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { UploadLogoModalComponent } from './upload-logo-modal';

export const UploadLogoModalModule: string = ng
    .module('archiSmall.userSettings.uploadLogoModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('uploadLogoModalComponent', UploadLogoModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/upload-logo-modal/upload-logo-modal.module.ts